import Analytics from '../../../../../analytics';

export const faOnAddAdult = noOfguests => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `guest_added|${noOfguests}`,
  });
};

export const faOnRemoveAdult = noOfguests => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `guest_removed|${noOfguests}`,
  });
};

export const faOnAddChildren = noOfguests => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `child_added|${noOfguests}`,
  });
};

export const faOnRemoveChildren = noOfguests => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `child_removed|${noOfguests}`,
  });
};

export const faOnAddRoom = noOfRooms => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `add_room|${noOfRooms}`,
  });
};

export const faOnRemoveRoom = roomNo => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `remove_room|${roomNo}`,
  });
};

export const faOnEditChanges = roomNo => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `pax_edit_changes|${roomNo}`,
  });
};
export const faOnApplyChanges = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'pax_apply_changes',
  });
};
